import * as React from "react";
import Text from "../text";
import { Select } from "antd";

interface Handles {
  focus: () => void;
}

interface IProps {
  value: string | number;
  id: string;
  label?: string;
  icon?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
  autoFocus?: boolean;
  searchable?: boolean;
  error?: string;
  disabled?: boolean;
  inlineLabel?: boolean;
  options?: { label: string; value: string | number }[];
  onChange?: (value: string | number) => void;
}

const Choice = React.forwardRef<Handles, IProps>(
  (
    {
      id,
      value = "",
      icon,
      placeholder = "Please select",
      error,
      options = [],
      searchable = false,
      disabled = false,
      label,
      inlineLabel = true,
      onChange,
    }: IProps,
    ref
  ) => {
    const inputRef = React.useRef<any>(null);

    React.useImperativeHandle(ref, () => ({
      focus: () => {
        inputRef.current?.focus();
      },
    }));

    return (
      <div className="flex flex-col flex-1">
        {label && !inlineLabel && (
          <label
            htmlFor={id}
            className={`mb-1 text-12 font-semibold 
              text-black/60
              `}
          >
            {label}
          </label>
        )}
        <div
          className={`relative border items-center !h-[45px] border-grey3 bg-white rounded-md overflow-hidden ${
            error && "!border-red"
          }`}
        >
          {icon && <div className="flex items-center pl-3">{icon}</div>}
          <div className="flex flex-1 relative">
            <Select
              id={id}
              showSearch={searchable}
              size="large"
              ref={inputRef}
              bordered={false}
              optionFilterProp="children"
              filterOption={(input: any, option: any) =>
                (option?.label.toLowerCase() ?? "").includes(
                  input.toLowerCase()
                )
              }
              placeholder={placeholder}
              disabled={disabled}
              value={typeof value === "string" ? value || null : value}
              onChange={(e) => {
                if (onChange) onChange(e);
              }}
              style={{
                height: "45px",
                fontFamily: "Poppins",
                display: "flex",
                alignItems: "center",
                textAlign: "left",
              }}
              className="w-full "
              options={options}
            />
          </div>
        </div>

        {error && (
          <div className="pt-1 pb-1">
            <Text size={11} color="red">
              {error}
            </Text>
          </div>
        )}
      </div>
    );
  }
);

export default Choice;
